import { render, staticRenderFns } from "./DescargueDuplicadoskiosco.vue?vue&type=template&id=421a3222&"
import script from "./DescargueDuplicadoskiosco.vue?vue&type=script&lang=js&"
export * from "./DescargueDuplicadoskiosco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports